import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { computed, ref } from 'vue'

interface FormDataType {
  isDeductionBaseMaterial: boolean
  isDisarm: boolean
  isDeductionSurplus: boolean
  isDeductionBujian: boolean
  isDeductionPaibanStore: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: { type: Boolean, default: false },
    data: { default: () => [] },
    showViewBtn: { type: Boolean },
    showDeductItem: { default: () => {
      return {
        isShowSurplusDeduction: true, // 显示扣减余料
        isShowBujianDeduction: true, // 显示扣减补件
        isShowAwaitDeduction: true, // 显示扣减暂存区小板
        isDisarm: true,
        isShowBaseMaterialDeduction: true,
      }
    } }
  },
  emits: ["update:visible", "success", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', val: boolean): void
  (e: 'success'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, data: string[], showViewBtn?: boolean, showDeductItem: {
      isShowSurplusDeduction: boolean // 显示扣减余料
      isShowBujianDeduction: boolean // 显示扣减补件
      isShowAwaitDeduction: boolean // 显示扣减暂存区小板
      isDisarm: boolean // 余料状态选择
      isShowBaseMaterialDeduction: boolean // 原片扣减
    } }

const labelCol = {
  xs: { span: 24 },
  sm: { span: 6 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}

const options = [
  {
    label: '是',
    value: true,
  },
  {
    label: '否',
    value: false,
  },
]
const options2 = [
  {
    label: '解除参与排版余料的锁定',
    value: true,
  },
  {
    label: '维持参与排版余料的锁定',
    value: false,
  },
]

// TODO: 原片扣减和余料状态选择，当前未上线，后续需要根据需求修改参数
const formData = ref<FormDataType>({
  isDisarm: false,
  isDeductionBaseMaterial:
    store.state.preferencesSetting?.setting.isDeductionBaseMaterial,
  isDeductionSurplus:
    store.state.preferencesSetting?.setting.isDeductionSurplus,
  isDeductionBujian: store.state.preferencesSetting?.setting.isDeductionBujian,
  isDeductionPaibanStore:
    store.state.preferencesSetting?.setting.isDeductionPaibanStore,
})





const visible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emit('update:visible', val)
    return true
  },
})

const confirmLoading = ref(false)
const handleOk = () => {
  updateLocalPreference(formData.value)
  visible.value = false
  emit('success')
}

// 关闭弹窗
const handleCancel = () => {
  visible.value = false
  emit('cancel')
}

return { __sfc: true,labelCol, wrapperCol, options, options2, formData, props, emit, visible, confirmLoading, handleOk, handleCancel }
}

})